import TxRendererScreenshotArea from "./components/TxRendererScreenshotArea";
import TxRendererProduct from "./components/TxRendererProduct";
import TxProductAspectRatio from "./components/TxProductAspectRatio";
import TxProductViewportScaler from "./components/TxProductViewportScaler";
import TxProductViewport from "./components/TxProductViewport";

import TxZoomBlocker from "./components/TxZoomBlocker";
import TxZoomControl from "./components/TxZoomControl";
import TxBlockOverlay from "./components/TxBlockOverlay";
import TxProductBorder from "./components/TxProductBorder";

import TxContent from "./components/TxContent";

export default {
    install(Vue, option) {

        Vue.component('TxZoomBlocker', TxZoomBlocker);
        Vue.component('TxZoomControl', TxZoomControl);
        Vue.component('TxBlockOverlay', TxBlockOverlay);
        Vue.component('TxProductBorder', TxProductBorder);

        Vue.component('TxProductViewport', TxProductViewport);
        Vue.component('TxProductViewportScaler', TxProductViewportScaler);
        Vue.component('TxProductAspectRatio', TxProductAspectRatio);
        Vue.component('TxRendererScreenshotArea', TxRendererScreenshotArea);
        Vue.component('TxRendererProduct', TxRendererProduct);

        Vue.component('TxContent', TxContent);
    }
};